import React from "react";

const Footer = () => {
  return (
    <>
      <footer className="footer">
        <div className="footer-container">
          <section className="footer-top">
            <div className="footer-left">
              <ul className="footer-col">
                <li>
                  <span className="footer-col-heading">HEALTHKART</span>
                </li>
                <li>
                  <a className="footer-links" href="#">
                    About Us
                  </a>
                </li>
                <li>
                  <a className="footer-links" href="#">
                    Contact Us
                  </a>
                </li>
                <li>
                  <a className="footer-links" href="#">
                    Refer & Earn
                  </a>
                </li>
                <li>
                  <a className="footer-links" href="#">
                    Loyalty Program
                  </a>
                </li>
                <li>
                  <a className="footer-links" href="#">
                    Loyalty
                  </a>
                </li>
                <li>
                  <a className="footer-links" href="#">
                    Blogs, Videos & More
                  </a>
                </li>
                <li>
                  <a className="footer-links" href="#">
                    Brand Directory
                  </a>
                </li>
                <li>
                  <a className="footer-links" href="#">
                    Authenticity Guaranteed
                  </a>
                </li>
                <li>
                  <a className="footer-links" href="#">
                    Careers
                  </a>
                </li>
              </ul>
              <ul className="footer-col">
                <li>
                  <span className="footer-col-heading">BRANDS</span>
                </li>
                <li>
                  <a className="footer-links" href="#">
                    MuscleBlaze
                  </a>
                </li>
                <li>
                  <a className="footer-links" href="#">
                    Fit Foods
                  </a>
                </li>
                <li>
                  <a className="footer-links" href="#">
                    HK Vitals
                  </a>
                </li>
                <li>
                  <a className="footer-links" href="#">
                    TrueBasics
                  </a>
                </li>
                <li>
                  <a className="footer-links" href="#">
                    Gritzo
                  </a>
                </li>
                <li>
                  <a className="footer-links" href="#">
                    bGREEN
                  </a>
                </li>
              </ul>
              <ul className="footer-col">
                <li>
                  <span className="footer-col-heading">HEALTH & FITNESS</span>
                </li>
                <li>
                  <a className="footer-links" href="#">
                    Bodybuilding
                  </a>
                </li>
                <li>
                  <a className="footer-links" href="#">
                    Hair & Skin Care
                  </a>
                </li>
                <li>
                  <a className="footer-links" href="#">
                    Sports Nutrition
                  </a>
                </li>
                <li>
                  <a className="footer-links" href="#">
                    Vitamins & Supplements
                  </a>
                </li>
                <li>
                  <a className="footer-links" href="#">
                    Ayurveda & Herbs
                  </a>
                </li>
                <li>
                  <a className="footer-links" href="#">
                    Health Food & Drinks
                  </a>
                </li>
                <li>
                  <a className="footer-links" href="#">
                    Fitness
                  </a>
                </li>
                <li>
                  <a className="footer-links" href="#">
                    Wellness
                  </a>
                </li>
                <li>
                  <a className="footer-links" href="#">
                    Consult Plans
                  </a>
                </li>
              </ul>
              <ul className="footer-col">
                <li>
                  <span className="footer-col-heading">POLICIES</span>
                </li>
                <li>
                  <a className="footer-links" href="#">
                    Terms & Conditions
                  </a>
                </li>
                <li>
                  <a className="footer-links" href="#">
                    Delivery Policy
                  </a>
                </li>
                <li>
                  <a className="footer-links" href="#">
                    Privacy Policy
                  </a>
                </li>
                <li>
                  <a className="footer-links" href="#">
                    Returns Policy
                  </a>
                </li>
              </ul>
              <ul className="footer-col">
                <li>
                  <span className="footer-col-heading">QUICK LINKS</span>
                </li>
                <li>
                  <a className="footer-links" href="#">
                    My Account
                  </a>
                </li>
                <li>
                  <a className="footer-links" href="#">
                    Track Your Order
                  </a>
                </li>
                <li>
                  <a className="footer-links" href="#">
                    Store Locator
                  </a>
                </li>
                <li>
                  <a className="footer-links" href="#">
                    HK Cash
                  </a>
                </li>
                <li>
                  <a className="footer-links" href="#">
                    HK Coupons
                  </a>
                </li>
                <li>
                  <a className="footer-links" href="#">
                    FAQs
                  </a>
                </li>
                <li>
                  <a className="footer-links" href="#">
                    Sell On HealthKart
                  </a>
                </li>
              </ul>
            </div>

            <div className="footer-col last-footer-col">
              <span className="footer-col-heading footer-side-heading">
                ABOUT HEALTHKART
              </span>
              <span className="footer-text">
                HealthKart.com is India’s largest online health & fitness store
                for men and women. Shop online from the latest collections of
                health, fitness and similar products featuring the best brands.
              </span>
              <span className="footer-col-heading footer-side-heading">
                SUBSCRIBE TO OUR NEWSLETTER
              </span>
              <span className="footer-text">
                Be the first one to receive amazing offers, deals and news
              </span>
              <form action=""></form>
              <div className="contacts">
                <p className="contact-heading">CONNECT WITH US</p>
                <div className="contact-links-container">
                  <a className="contact-link" href="#">
                    <ion-icon
                      className="contact-icon"
                      name="logo-facebook"
                    ></ion-icon>
                  </a>
                  <a className="contact-link" href="#">
                    <ion-icon
                      className="contact-icon"
                      name="logo-instagram"
                    ></ion-icon>
                  </a>
                  <a className="contact-link" href="#">
                    <ion-icon
                      className="contact-icon"
                      name="logo-linkedin"
                    ></ion-icon>
                  </a>
                  <a className="contact-link" href="#">
                    <ion-icon
                      className="contact-icon"
                      name="logo-twitter"
                    ></ion-icon>
                  </a>
                  <a className="contact-link" href="#">
                    <ion-icon
                      className="contact-icon"
                      name="logo-youtube"
                    ></ion-icon>
                  </a>
                  <a className="contact-link" href="#">
                    <ion-icon
                      className="contact-icon"
                      name="logo-pinterest"
                    ></ion-icon>
                  </a>
                </div>
              </div>
            </div>
          </section>
          <hr />
          <section className="footer-bottom">
            <div className="seals">
              <a href="#">
                <img
                  src="https://static1.hkrtcdn.com/hknext/static/media/common/footer/hk-consult.svg
              "
                  alt="HealthKart consult"
                />
              </a>
              <a href="#">
                <img
                  src="https://static1.hkrtcdn.com/hknext/static/media/common/footer/A-G.svg"
                  alt="Authenticity Guaranteed"
                />
              </a>
              <a href="#">
                <img
                  src="	https://static1.hkrtcdn.com/hknext/static/media/common/footer/RP.svg
              "
                  alt="14 Day Return Policy"
                />
              </a>
            </div>
            <div className="disclaimer">
              <span className="disclaimer-heading">Disclaimer:</span>
              <span className="disclaimer-text">
                The information contained on HealthKart (www.healthkart.com or
                subdomains) is provided for informational purposes only and is
                not meant to substitute for the advice provided by your doctor
                or other healthcare professional. Information and statements
                regarding products, supplements, programs etc listed on
                HealthKart have not been evaluated by the Food and Drug
                Administration or any government authority and are not intended
                to diagnose, treat, cure, or prevent any disease. Please read
                product packaging carefully prior to purchase and use. The
                results from the products will vary from person to person. No
                individual result should be seen as typical.
              </span>
            </div>
          </section>
          <hr />
          <section className="copyright-download">
            <div className="copyright-text">
              Copyright &copy; 2022, HealthKart.com, or its affiliates
            </div>
            <div className="download">
              <span className="download-text">DOWNLOAD OUR APP</span>
              <div className="download-icon">
                <a href="#">
                  <img
                    className="download-apple"
                    src="	https://static1.hkrtcdn.com/hknext/static/media/common/footer/App-Store.svg
              "
                    alt="Available on the app store"
                  />
                </a>
                <a href="#">
                  <img
                    className="download-android"
                    src="	https://static1.hkrtcdn.com/hknext/static/media/common/footer/Google-Play.svg
              "
                    alt="Available on the app store"
                  />
                </a>
              </div>
            </div>
          </section>
        </div>
      </footer>
    </>
  );
};

export default Footer;
